/**
*
* FontProvider
*
*/

import PropTypes from 'prop-types';
import styled from 'styled-components';
import fontConfiguration from './fontConfiguration';

const FontProvider = styled.div.attrs({
  font: ({ country, language }) => fontConfiguration(country, language),
})`
  font-family: ${(props) => props.font}, "Noto Sans", "Noto Sans KR", "Noto Sans JP", "Noto Sans TC", "Noto Sans SC", "Noto Sans HK", "Roboto", "Open Sans", "sans-serif";
  `;

FontProvider.propTypes = {
  country: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default FontProvider;
